import OSS from 'ali-oss'
const client = new OSS({
  region: 'oss-cn-qingdao',
  accessKeyId: 'LTAI5t7bxHfBcaZchDzNdcHB',
  accessKeySecret: 'eeX0wZEoLDEwUveColjMVwYviQkI5B',
  bucket: 'yytc-img'
})
export default client


// WEBPACK FOOTER //
// ./src/utils/ossClient.js